class GlobalSrv {
  constructor ($resource, SERVICE_URL_CONSTANT, WorkPlanSrv, $cookies) {
  // Other Services
    var roles = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
      getAccessModules: {
        method: 'GET',
        params: {
          type: 'subject',
          route: 'getEvaluatorAssingnedSubmodule'
        }
      }
    })

    var getUserInfo = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherIdByUserId', {}, {
      get: {
        method: 'POST'
      }
    })

    var getUserInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationsInbox', {}, {
      get: {
        method: 'POST'
      }
    })
    
    var getScheduledInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getScheduledNotificationsInbox', {}, {
      get: {
        method: 'POST'
      }
    })

    var getPerfilDash = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/perfil_dash/:teacherId', {}, {
      get: {
        method: 'GET'
      }
    })

    var getUserImage = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getUserImage/:identification', {}, {
      get: {
        method: 'GET'
      }
    })

    var getUserInboxAllNoRead = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getUserInboxAllNoRead', {}, {
      get: {
        method: 'POST'
      }
    })

    var updateNotificationReadingMessagesUserInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotificationReadingMessagesUserInbox', {}, {
      update: {
        method: 'POST'
      }
    })

    var getCountNotificationsUserInboxNoRead = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getCountNotificationsUserInboxNoRead', {}, {
      get: {
        method: 'POST'
      }
    })

    var getUserByRol = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getUserByRol', {}, {
      get: {
        method: 'POST'
      }
    })
    var getChangeRole = $resource(SERVICE_URL_CONSTANT.userApi + '/api/user-api/changerole', {}, {
      get: {
        method: 'GET'
      }
    })

    var getElementsRightBar = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getWorkPlanGeneral', {}, {
      getList: {
        method: 'POST'
      }
    })


    var addNotificationToAdminWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminWorkPlan', {}, {
      add: {
        method: 'POST'
      }
    })

    var addNotificationToMainEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationToMainEvaluator', {}, {
      add: {
        method: 'POST'
      }
    })

    var addNotificationToReviewers = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationToReviewers', {}, {
      add: {
        method: 'POST'
      }
    })

    var addNotificationsToAdminByTeacherAM = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminByTeacherAM', {}, {
      add: {
        method: 'POST'
      }
    })

    var addNotificationsEvaluatorsSubmodule = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsEvaluatorsSubmodule', {}, {
      add: {
        method: 'POST'
      }
    })

    var addNotificationsToAdminEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminEvaluator', {}, {
      add: {
        method: 'POST'
      }
    })

  var getUserInfoMetta = $resource(SERVICE_URL_CONSTANT.userApi+ '/api/user-api/getUserInfo', {}, {
      POST: {
        method: 'POST'
      }
    })

    var jobForeachPureApi = $resource(SERVICE_URL_CONSTANT.rosario + '/report/jobForeachPureApi', {}, {
      execute: {
        method: 'GET'
      }
    })

    function subscribe (scope, root, message, callback) {
      var handler = root.$on(message, (event, data) => {
        callback(data)
      })
      scope.$on('$destroy', handler)
    }

    function notify (root, message, object) {
      root.$emit(message, object)
    }

    function sendNotification (data) {
      WorkPlanSrv.addNotificationsTransactions.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationAdmin (data) {
      WorkPlanSrv.addNotificationsTransactionsToAdmin.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationToMainEvaluator (data) {
      addNotificationToMainEvaluator.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationAdminAM (data) {
      addNotificationsToAdminByTeacherAM.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationToReviewers (data) {
      addNotificationToReviewers.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationsEvaluatorsSubmodule (data) {
      addNotificationsEvaluatorsSubmodule.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function sendNotificationsToAdminEvaluator (data) {
      addNotificationsToAdminEvaluator.add(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log('Notificación exitosa', dataReturn)
        } else {
          console.log('Error de comunicación en la notificación')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getReviewers (idRole) {
      let reviewers
      try {
        reviewers = JSON.parse($cookies.get('reviewers'))
      } catch (e) {
        reviewers = []
      }
      let evaluators = []
      let evaluator = ''
      for (var index in reviewers) {
        if (reviewers[index].idRole === idRole) {
          if (evaluator != reviewers[index].idEvaluator) {
            evaluators.push(reviewers[index].idEvaluator)
            evaluator = reviewers[index].idEvaluator
          }
        }
      }
      return evaluators
    }

    function getReviewersAndEvaluator () {
      let reviewers
      try {
        reviewers = JSON.parse($cookies.get('reviewers'))
      } catch (e) {
        reviewers = []
      }
      let evaluators = []
      let evaluator = ''
      for (var index in reviewers) {
        if (evaluator != reviewers[index].idEvaluator) {
          evaluators.push(reviewers[index].idEvaluator)
          evaluator = reviewers[index].idEvaluator
        }
      }
      return evaluators
    }

    function getReviewerbySubmodule (idRole, idSubmodule) {
      let reviewers
      let reviewersToSend = []
      try {
        reviewers = JSON.parse($cookies.get('reviewers'))
      } catch (e) {
        reviewers = []
      }
      if (idSubmodule) {
        reviewers.forEach(function (reviewer) {
          if (reviewer.idRole === idRole && reviewer.idSubmodule === idSubmodule) {
            reviewersToSend.push(reviewer.idEvaluator)
          }
        })
      } else {
        reviewers.forEach(function (reviewer) {
          if (reviewer.idRole === idRole) { reviewersToSend.push(reviewer.idEvaluator) }
        })
      }
      if (reviewersToSend.length > 0) {
        return reviewersToSend
      } else { return false }
    }

    return {
      getUserInfo: getUserInfo,
      getUserInbox: getUserInbox,
      getScheduledInbox : getScheduledInbox,
      getUserInboxAllNoRead: getUserInboxAllNoRead,
      updateNotificationReadingMessagesUserInbox: updateNotificationReadingMessagesUserInbox,
      getCountNotificationsUserInboxNoRead: getCountNotificationsUserInboxNoRead,
      subscribe: subscribe,
      getChangeRole: getChangeRole,
      notify: notify,
      roles: roles,
      sendNotification: sendNotification,
      getElementsRightBar: getElementsRightBar,
      getReviewers: getReviewers,
      getReviewerbySubmodule: getReviewerbySubmodule,
      getUserByRol: getUserByRol,
      sendNotificationAdmin: sendNotificationAdmin,
      addNotificationToAdminWorkPlan: addNotificationToAdminWorkPlan,
      sendNotificationToMainEvaluator: sendNotificationToMainEvaluator,
      sendNotificationToReviewers: sendNotificationToReviewers,
      getReviewersAndEvaluator: getReviewersAndEvaluator,
      sendNotificationAdminAM: sendNotificationAdminAM,
      sendNotificationsEvaluatorsSubmodule: sendNotificationsEvaluatorsSubmodule,
      sendNotificationsToAdminEvaluator: sendNotificationsToAdminEvaluator,
      getUserInfoMetta:getUserInfoMetta,
      jobForeachPureApi:jobForeachPureApi,
      getPerfilDash: getPerfilDash,
      getUserImage:getUserImage
    }
  }
}
GlobalSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT', 'WorkPlanSrv', '$cookies']
export default angular.module('services.GlobalSrv', []).service('GlobalSrv', GlobalSrv).name



// WEBPACK FOOTER //
// ./src/globalSrv.js